import { render, staticRenderFns } from "./FundDestinations.vue?vue&type=template&id=7c27b9d8&scoped=true"
import script from "./FundDestinations.vue?vue&type=script&lang=js"
export * from "./FundDestinations.vue?vue&type=script&lang=js"
import style0 from "./FundDestinations.vue?vue&type=style&index=0&id=7c27b9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c27b9d8",
  null
  
)

export default component.exports